import { IIcon } from "constants/interfaces";

const ChevronLeftIcon = ({ color }: IIcon) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<path
				d="M14.5 6L8.5 12L14.5 18"
				stroke={`var(--${color ? color : "icon-primary"})`}
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};

export default ChevronLeftIcon;
